import { render, staticRenderFns } from "./ArtistsAgainst419.vue?vue&type=template&id=03acba81&"
import script from "./ArtistsAgainst419.vue?vue&type=script&lang=js&"
export * from "./ArtistsAgainst419.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports